import { Building2 } from 'lucide-react';

// NOTE: The Lysekil kommun pilot partner card is currently HIDDEN — see SHOW_LYSEKIL_PILOT below.
// To re-enable, set the flag to true (and replace the placeholder logo with the real one).
const SHOW_LYSEKIL_PILOT = false;

export const Partners = () => {
    const ecosystemLogos = [
        {
            name: 'Venture Cup',
            image: '/images/Venture-cup-logga.png',
            link: 'https://www.venturecup.se/en/',
        },
        {
            name: 'BLING',
            image: '/images/a01809e7-eb3b-4b9f-b1e2-0b739d0b4177.png',
            link: 'https://www.blingstartup.se/',
        },
        {
            name: 'DigitalWell',
            image: '/images/56cc9de4-66ad-4909-b493-b6c6fb0ca3aa.png',
            link: 'https://www.digitalwellventures.com/digitalwell-incubator',
        },
        {
            name: 'Företagarna',
            image: '/images/Företagarna.png',
            link: 'https://www.foretagarna.se/kampanjer/103-unga-ideer/',
        },
        {
            name: 'Destination Invest',
            image: '/images/Destination-Invest.png',
            link: '',
        },
    ];

    return (
        <section className="flex flex-col justify-center px-6 sm:px-12 md:px-24 py-12 md:py-16 min-h-screen w-full text-[#212121] bg-neutral-50">
            {/* Section title */}
            <h2 className="font-switzer text-3xl sm:text-4xl md:text-5xl font-bold text-center leading-tight md:leading-[56px]">
                Förtroende från kommuner och ekosystem
            </h2>
            <p className="font-inter mt-4 text-base sm:text-lg md:text-xl text-center max-w-3xl mx-auto text-[#212121]/70">
                Nexilink används redan i välfärden och är erkänt av ledande innovationsaktörer i Sverige.
            </p>

            {/* ROW 1 — Customer proof: Lysekil kommun (highlighted pilot partner) — hidden for now */}
            {SHOW_LYSEKIL_PILOT && (
                <div className="mt-12 max-w-4xl mx-auto w-full">
                    <div className="flex flex-col md:flex-row items-center gap-6 p-8 bg-white rounded-2xl border-2 border-teal-200 shadow-md">
                        <div className="flex-shrink-0 w-32 h-32 bg-teal-50 rounded-xl flex items-center justify-center">
                            {/* Placeholder for Lysekil kommun logo — replace with actual logo when available */}
                            <Building2 className="w-16 h-16 text-teal-700" />
                        </div>
                        <div className="flex-1 text-center md:text-left">
                            <div className="inline-block px-3 py-1 bg-teal-100 text-teal-800 text-xs font-bold uppercase tracking-wide rounded-full mb-3">
                                Pilotpartner
                            </div>
                            <h3 className="font-switzer text-2xl font-bold text-[#212121] mb-2">
                                Lysekil kommun
                            </h3>
                            <p className="font-inter text-[#212121]">
                                Använder Nexilink för att digitalisera onboardingen av nya medarbetare i välfärden.
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {/* ROW 2 — Ecosystem proof */}
            <div className="mt-16">
                <p className="font-inter text-center text-sm font-semibold text-[#212121] uppercase tracking-wider mb-8">
                    Erkända av
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
                    {ecosystemLogos.map((partner, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center p-8 rounded-lg border border-neutral-200 bg-white"
                        >
                            <div className="w-full h-32 flex items-center justify-center">
                                <img
                                    src={partner.image}
                                    alt={partner.name}
                                    className="max-w-full max-h-full object-contain"
                                    onError={(e) => {
                                        const target = e.currentTarget;
                                        if (!target.dataset.errorHandled) {
                                            target.dataset.errorHandled = 'true';
                                            target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='100' viewBox='0 0 200 100'%3E%3Crect width='200' height='100' fill='%23f3f4f6'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial, sans-serif' font-size='14' fill='%236b7280'%3E${encodeURIComponent(partner.name)}%3C/text%3E%3C/svg%3E`;
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
